import React from 'react'
import styled from '../../config/theme'
import InputView from './InputView'

export default function DisplayView ({ items }: DisplayViewProps) {
  return (
    <div>
      {items.filter(row => row.length > 0).map((row, rowIndex) => (
        <Row
          key={rowIndex}
        >
          {row.map((item, index) => (
            <Column
              key={index}
              size={item.size}
            >
              <InputView
                label={item.label}
                value={item.value}
                color={item.color}
                url={item.url}
              />
            </Column>
          ))}
        </Row>
      ))}
    </div>
  )
}

export interface DisplayViewProps {
  items: {
    label: string
    value: any
    size: number
    color?: string
    url?: string
  }[][]
}

const Row = styled.div`
  @media screen and (min-width: 1000px) {
    display: flex;
    width: 100%;
    margin: 0 -10px;
    margin-bottom: 20px;
  }
`

const Column = styled.div<{ size: number }>`
  margin-bottom: 20px;

  @media screen and (min-width: 1000px) {
    width: calc(${props => props.size}% - 15px);
    margin-right: 15px;
    margin-bottom: 0;
  }
`
